export default "__VITE_ASSET__DVWN3L79__"